import { FormControl, Grid, Paper, TextField } from "@mui/material";
import { MRT_ColumnDef } from "material-react-table";
import { useEffect, useMemo, useState } from "react";
import { ValidatorForm } from "react-material-ui-form-validator";
import { IEventListData } from "../../_common/interface/event/iEventListData";
import { IFilteringViewModel } from "../../_common/interface/table";
import StyledGrid from "../../_components/grid/styledGrid";
import { PageHeader } from "../../_components/header/page.header";
import { CommonTable } from "../../_components/table/common.table";
import { handleErrorResponse } from "../../_helpers/handleResponse.helper";
import { usersService } from "../../_services/users.service";
import { useContainerStyles } from "../../_styles/container.styles";
import { useNavigate } from "react-router-dom";
import { PrimaryButton } from "../../_components/button/primary.button";
import { getDate, getDateString, getDateTime } from "../../_helpers/dateTime.helper";
import moment from "moment";
import { accountService } from "../../_services/accounts.service";

export function UserIndex() {
    let navigate = useNavigate();

    const [data, setData] = useState<IEventListData>({ items: [], count: 0 });
    const [isLoading, setLoading] = useState(false);
    const [isInit, setInit] = useState(false);
    const [filter, setFilter] = useState<IFilteringViewModel | null>(null);

    const [search, setSearch] = useState<IFilteringViewModel>({
        name: ''
    });

    const columns = useMemo<MRT_ColumnDef<any>[]>(
        () => [
            {
                accessorKey: 'name',
                header: 'Name',
            },
            {
                accessorKey: 'id',
                header: 'Racing Licences',
                accessorFn: (rowData: any) => <>
                    <>{(rowData.racingLicenseNumbers && rowData.racingLicenseNumbers.length) ? "Motor Licences: " + rowData.racingLicenseNumbers.join(", ") : ""}</>
                    <>{(rowData.officialLicenseNumbers && rowData.officialLicenseNumbers.length) ? " Official Licences: " + rowData.officialLicenseNumbers.join(", ") : ""}</>
                    <>{rowData.mediaLicenseNumber ? " Media Accreditations: " + rowData.mediaLicenseNumber : ""}</>
                </>,
            },
            ...(!accountService.isOrganiser ? [
                {
                    accessorKey: 'email',
                    header: 'Email',
                    accessorFn: (rowData: any) => <>{<a href={`mailto:${rowData.email}`}>{rowData.email}</a>}</>,
                },
            ] : []),

            ...(!accountService.isOrganiser ? [
                {
                    accessorKey: 'phone',
                    header: 'Phone',
                },
            ] : []),
            {
                accessorKey: 'dateOfBirth',
                header: 'DOB',
                accessorFn: (rowData: any) => <>{getDate(rowData.dateOfBirth)}</>,
            },

        ],
        [],
    );

    useEffect(() => {
        if (filter) {
            if (isInit) {
                fetchData();
            }
            else
                setInit(true);
        }
    }, [filter]);

    function fetchData() {
        setLoading(true)
        return usersService.getAllUsers({ ...filter, ...search })
            .then(
                data => {
                    setData(data);
                }, handleErrorResponse)
            .finally(() => {
                setLoading(false);
            });
    }

    function handleChange(event: any) {
        setSearch((__filter: any) => { return { ...__filter, [event.target.name]: event.target.value } });
    };

    return (
        <>
            <div style={useContainerStyles.root}>

                <PageHeader
                    pageName="Users"
                />
                <Paper>

                    <ValidatorForm onSubmit={fetchData}>
                        <StyledGrid container spacing={2}>

                            <Grid item lg={2} md={6} xs={12}>
                                <FormControl fullWidth>
                                    <TextField label="Name" name="name" value={search.name} onChange={handleChange} placeholder="Name" variant="outlined" />
                                </FormControl>
                            </Grid>

                            <Grid item lg={2} md={6} xs={12}>
                                <FormControl fullWidth>
                                    <TextField label="Licence Number" name="licenseNumber" value={search.licenseNumber} onChange={handleChange} type="number" placeholder="Licence Number" variant="outlined" />
                                </FormControl>
                            </Grid>

                            {!accountService.isOrganiser &&
                                <>
                                    <Grid item lg={2} md={6} xs={12}>
                                        <FormControl fullWidth>
                                            <TextField label="Email" name="email" value={search.email} onChange={handleChange} placeholder="Email" variant="outlined" />
                                        </FormControl>
                                    </Grid>

                                    <Grid item lg={2} md={6} xs={12}>
                                        <FormControl fullWidth>
                                            <TextField label="Phone Number" name="phone" value={search.phone} onChange={handleChange} placeholder="Phone Number" variant="outlined" />
                                        </FormControl>
                                    </Grid>
                                </>
                            }

                            <Grid item lg={2} md={6} xs={12}>
                                <FormControl fullWidth>
                                    <TextField label="DOB" name="dateOfBirth" onPaste={(e: any) => {
                                        e.stopPropagation();
                                        e.preventDefault();

                                        var clipboardData = e.clipboardData || (window as any).clipboardData;
                                        var pastedData = clipboardData.getData('Text');
                                        if (pastedData) {
                                            var d = moment(pastedData, "DD/MM/YYYY").format('YYYY-MM-DD');
                                            if (d)
                                                setSearch(s => ({ ...s, dateOfBirth: d }))
                                        }
                                    }} value={search.dateOfBirth} type="date" onChange={handleChange} InputLabelProps={{
                                        shrink: true,
                                    }}
                                    />
                                </FormControl>
                            </Grid>
                            <Grid item lg={2} md={6} xs={12}>
                                <PrimaryButton
                                    fullHeight
                                    isLoading={isLoading}
                                    type="submit"
                                    variant="save">{"Search"}
                                </PrimaryButton>
                            </Grid>
                        </StyledGrid>
                    </ValidatorForm>

                    <CommonTable
                        columns={columns}
                        data={data}
                        filter={filter}
                        onEdit={(d: any) => {
                            if (accountService.isOrganiser) {
                                navigate(d.toString() || "")
                            }
                            else {
                                (window as any).open("Users/" + d.toString() || "", '_blank').focus();

                            }

                        }}
                        setFilter={setFilter}
                        isLoading={isLoading}
                        pageSize={100}
                    />

                </Paper>

            </div>
        </>

    );

}
